import logo from "../images/logo_flowclips.gif"

function Footer() {
  return (
    <footer className="mt-16 border-t border-zinc-800 py-10 px-6 text-center">
      <img src={logo} alt="FlowClips Logo" className="h-16 mx-auto mb-4" />
      <p className="text-sm text-zinc-500">
        Developed by{" "}
        <a
          href="https://www.somnum.net"
          target="_blank"
          rel="noreferrer"
          className="text-zinc-400 hover:text-white transition-colors"
        >
          SOMNUM
        </a>
      </p>
    </footer>
  )
}

export default Footer
